import React, { useCallback } from 'react';
import ReactSelect from 'react-select';

export const dropdownStyle = {
  control: (provided, _state) => ({
    ...provided,
    borderColor: '#dde6e9',
    borderWidth: '2px',
    height: '3.125rem',
  }),
  singleValue: (provided, _state) => ({
    ...provided,
    color: '#586474',
  }),
  option: (provided, state) => ({
    ...provided,
    color: '#586474',
    ':active': {
      ...provided[':active'],
      backgroundColor: '#CCF0F9',
    },
    backgroundColor: state.isFocused && '#CCF0F9',
  }),
};

type SelectProps = React.ComponentProps<typeof ReactSelect>;

export default function Select({
  value,
  placeholder,
  options,
  onChange,
  ...rest
}: SelectProps) {
  const handleChange = useCallback(
    ({ value: v }, e) => onChange?.(v, e),
    [onChange],
  );
  const selectedOption =
    (value || value === 0) && options.find((o: any) => o.value === value);
  return (
    <ReactSelect
      value={selectedOption}
      placeholder={placeholder}
      options={options}
      styles={dropdownStyle}
      menuPortalTarget={document.querySelector('body')}
      onChange={handleChange}
      {...rest}
    />
  );
}
